import { browserId, BrowserOrServerId } from 'Browser/BrowserId';
import {SiteType} from 'Common/SiteType';

export type SiteKey = string;


export class SiteBasics<EitherId extends BrowserOrServerId>
{
	constructor(
		readonly id:EitherId,
		readonly type:SiteType,
		readonly key:SiteKey,
		readonly hostUrl: string
	) 
	{ }
}

export function convertSiteId(site)
{
	const newSite = {...site};
	newSite.id = browserId(site.id);
	return newSite;
}

